import type { ChainType } from "~/api/types";

const ADDRESS_PATTERNS: Record<ChainType, RegExp> = {
  evm: /^0x[a-fA-F0-9]{40}$/,
  solana: /^[1-9A-HJ-NP-Za-km-z]{32,44}$/,
  tron: /^T[1-9A-HJ-NP-Za-km-z]{33}$/,
};

export function isValidAddress(address: string, chainType: ChainType): boolean {
  return ADDRESS_PATTERNS[chainType].test(address);
}
